import { render, staticRenderFns } from "./PricingList.vue?vue&type=template&id=02c583a8&scoped=true"
import script from "./PricingList.vue?vue&type=script&lang=js"
export * from "./PricingList.vue?vue&type=script&lang=js"
import style0 from "./PricingList.vue?vue&type=style&index=0&id=02c583a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c583a8",
  null
  
)

export default component.exports